
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.321 2.357C3.893.786 5.786 0 8 0c2.214 0 4.101.78 5.66 2.34C15.22 3.898 16 5.785 16 8s-.78 4.101-2.34 5.66C12.102 15.22 10.215 16 8 16s-4.101-.78-5.66-2.34C.78 12.102 0 10.215 0 8s.774-4.095 2.321-5.643zm9.786 2.964c.024-.023.036-.06.036-.107 0-.071-.012-.119-.036-.143L11 4.214c-.024-.024-.071-.035-.143-.035-.047 0-.083.011-.107.035L6.786 9.321c-1.048-1-1.584-1.511-1.607-1.535-.072-.072-.143-.107-.215-.107-.024 0-.071.035-.143.107l-.928.928c-.024.024-.036.072-.036.143 0 .048.012.083.036.107L3.964 9a2990.43 2990.43 0 012.822 2.714c.071.072.13.107.178.107.048 0 .107-.035.179-.107l4.964-6.393z","fill":"#57C49F"}})])
          )
        }
      }
    